import { ProductionStatus } from "@enums/productionStatus.enum";

export function GetProductionStatusColorOpsPlanner(status: ProductionStatus) {
	switch (status) {
		case ProductionStatus.Active:
		case ProductionStatus.Changeover:
			return "#F0FDF4";
		case ProductionStatus.ToiletBreak:
		case ProductionStatus.Break:
		case ProductionStatus.QLoop:
		case ProductionStatus.QualityCheck:
		case ProductionStatus.AssistanceRequired:
			return "#FDF2F2";
		case ProductionStatus.Idle:
		case ProductionStatus.Inactive:
		case ProductionStatus.InitialCheckFailed:
		case ProductionStatus.Breakdown:
		case ProductionStatus.Maintenance:
			return "#FDF2F2";
		default:
			return "blue";
	}
}